/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nft.vue?vue&type=template&id=ac4a0670"
import script from "./nft.vue?vue&type=script&lang=js"
export * from "./nft.vue?vue&type=script&lang=js"
import style0 from "./nft.vue?vue&type=style&index=0&id=ac4a0670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports